module.exports = __webpack_public_path__ + "static/media/Landorus_gaussian2.be091dce.png";